import { datadogRum } from '@datadog/browser-rum';
import { t } from 'i18next';
import toast from 'react-hot-toast';

import ToastMessageBlock from '@/components/Toasts/SuccessToast';

import Constants from '@/constants';

import { queryClient } from '@/services';

import {
  deleteCategoryByCountryCodeAndId,
  getCategoryByCountryCodeQueryKey,
} from '@/_generated/api-clients/content';
import { getAdminState, setAdminState } from '@/routes/Admin/state';

export const deleteCategory = async (name?: string) => {
  const { selectedCountry, editingCategory, temporaryCategory } =
    getAdminState();

  if (name) {
    setAdminState('editingCategory', undefined);
  }

  try {
    await deleteCategoryByCountryCodeAndId({
      path: {
        country: selectedCountry.label,
        id: editingCategory?.id ?? temporaryCategory.id ?? '',
      },
      throwOnError: true,
    });

    queryClient.invalidateQueries({
      queryKey: getCategoryByCountryCodeQueryKey({
        query: {
          isAdmin: true,
          country: selectedCountry.label,
        },
      }),
    });

    toast.custom(toastObj => (
      <ToastMessageBlock id={toastObj.id}>
        {t('Admin.deleteCategoryToast', {
          categoryName: name,
        })}
      </ToastMessageBlock>
    ));
  } catch (err) {
    console.error(err);
    toast.custom(toastObj => (
      <ToastMessageBlock id={toastObj.id} severity="error">
        {Constants.IS_IN_CYPRESS_TEST_LOCAL || Constants.IS_IN_JEST_TEST
          ? 'Delete Category Fail In Cypress Test'
          : (err as { error: string }).error}
      </ToastMessageBlock>
    ));
    datadogRum.addError(err);
  }
  setAdminState('confirmationModalType', null);
};
